export const navSwimMenu = [
	{ label: 'All Swim', url: '/collections/all' },
	{ label: 'New Arrivals', url: '/collections/new-arrivals' },
	{ label: 'Tops', url: '/collections/tops' },
	{ label: 'Bottoms', url: '/collections/bottoms' },
	{ label: 'One Piece', url: '/collections/one-piece-swimwear' },
	{ label: 'Solids', url: '/collections/solids' },
	{ label: 'Textured', url: '/collections/the-textured-collection' },
	{ label: 'Tankinis', url: '/collections/tankinis' },
]

export const navApparelMenu = [
	{ label: 'Back To School Apparel', url: '/collections/apparel/' },
	{ label: 'All Accessories', url: '/collections/accessories' },
	{ label: 'Tanks & Tees', url: '/collections/tanks-tees' },
	{ label: 'Dresses & Skirts', url: '/collections/dresses-skirts' },
	{ label: 'Shorts', url: '/collections/shorts' },
	{ label: 'Bags', url: '/collections/bags' },
	{ label: 'Men\'s Collection', url: '/collections/mens-collection' },
	{ label: 'Matching Couple Suits', url: '/collections/his-hers' },
]

export const navCollectionMenu = [
  //{label: 'All Collections', url: '/collections/all'},
  
  { label: "Sunchasers ☀", url: "/collections/the-ashley-kelly-edit-sunchasers/" },
  {
	label: "Island Life ☀",
	url: "/collections/the-ashley-kelly-edit-island-life/",
  },
  { label: "Bratz® x Blackbough", url: "/collections/bratz/" },
  { label: "Sanctuary", url: "/collections/the-sanctuary-collection/" },
  { label: "Deep Dive", url: "/collections/the-deep-dive-collection/" },
  {
    label: "Caramel Eyelet",
    url: "/collections/the-caramel-eyelet-collection/",
  },
  { label: "Sunsoaked", url: "/collections/the-sunsoaked-collection/" },
  { label: "Butter Yellow", url: "/collections/the-butter-yellow-collection/" },
  
  
]
